// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  position: relative;
  height: 100vh;
  background: var(--bg-primary);
  overflow: hidden;
}

/* Sidebar grid layout container */
.app-layout {
  display: flex;
  height: 100vh;
  width: 100%;
}

.main-viewport {
  margin-left: 260px; /* Sidebar width */
  flex: 1 1;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  overflow-x: hidden;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB,EAAE,kBAAkB;EACtC,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".app {\n  position: relative;\n  height: 100vh;\n  background: var(--bg-primary);\n  overflow: hidden;\n}\n\n/* Sidebar grid layout container */\n.app-layout {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n}\n\n.main-viewport {\n  margin-left: 260px; /* Sidebar width */\n  flex: 1;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
